/**
 * @fileoverview GET handler for the "/app_groups/:app_group_id/placements/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsId } from "./constants";
import type { GetAppGroupsAppGroupIdPlacementsIdResult } from "./types";

export const getAppGroupsAppGroupIdPlacementsId = reactQueryFetcherAdapter(
  appGroupsAppGroupIdPlacementsId,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<GetAppGroupsAppGroupIdPlacementsIdResult> => {
    return fetch(`/app_groups/${appGroupId}/placements/${id}`, "GET", {}, { signal });
  }
);
